import { Breakpoints, Container, Layout, LayoutConfiguration, styled } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CarlineEquipments, CarlineModelCuotaInfo, Comparador, SideViewImageOffer } from 'src/components';
import { CarlineContext, useFeatureAppConfig } from 'src/feature-app/hooks';
import { Offer } from 'src/types';
import { css } from 'styled-components';
import { isCommercial } from 'src/bff/get-data-url';
import { getDataServiceConfig } from 'src/feature-app';

type OfferProps = {
  showCard: boolean;
};
const Offer = styled.div<OfferProps>`
  width: 100%;
  opacity: ${(props) => (props.showCard ? '1' : '0')};
  ${(props) =>
    !props.showCard &&
    css`
      &.offer-enter {
        opacity: 0;
      }
      &.offer-enter-active {
        opacity: 1;
        transition: opacity 400ms ease-in;
      }
      &.offer-enter-done {
        opacity: 1;
      }
      &.offer-exit {
        opacity: 1;
      }
      &.offer-exit-active {
        opacity: 0.01;
        transition: opacity 1ms;
      }
    `};
`;

const ComparadorContainer = styled.div`
  width: 100%;
  &.comparador-enter {
    transform: translate3d(0, -20%, 0);
    opacity: 0.01;
    display: block;
  }
  &.comparador-enter-active {
    transform: translate3d(0, 0, 0);
    opacity: 1;
    transition: transform 200ms, opacity 300ms ease-in;
    display: block;
  }
  &.comparador-enter-done {
    display: block;
  }
  &.comparador-exit {
    transform: translate3d(0, 0, 0);
    opacity: 1;
    display: block;
  }
  &.comparador-exit-active {
    transform: translate3d(0, -20%, 0);
    opacity: 0.01;
    transition: all 200ms;
    display: block;
  }
`;

type EquipmentWrapperProps = {
  oneOffer: boolean;
};
const ComparadorWrapper = styled.div<EquipmentWrapperProps>`
  align-self: flex-end;
  padding-bottom: ${(props) => (props.oneOffer ? '60px' : '40px')};
  padding-top: 44px;
  @media (min-width: 560px) {
    padding-bottom: 0;
  }
  @media screen and (min-width: 960px) {
    padding-top: ${(props) => (props.oneOffer ? '0' : '44px')};
  }
`;
interface CarlineOfferProps {
  offer: Offer;
  offerNumber?: number;
  activeComparador: boolean;
  numberOfOffers: number;
  offerChange?: boolean;
  showCard: boolean;
  setSelectedOffer?: React.Dispatch<React.SetStateAction<Offer>>;
  setShowOfferToFalse?: () => void;
  unSelectCarline?: () => void;
  setShowLead?: React.Dispatch<React.SetStateAction<boolean>>;
}

const moreThanOneOffer: LayoutConfiguration = {
  [Breakpoints.default]: [
    { name: 'a', columns: 24 },
    { name: 'b', columns: 24 },
    { name: 'c', columns: 24 },
  ],
};

const oneOfferCommercial: LayoutConfiguration = {
  [Breakpoints.default]: [
    { name: '.', columns: 2 },
    { name: 'a', columns: 20 },
    { name: '.', columns: 2 },
    { name: '.', columns: 2 },
    { name: 'b', columns: 20 },
    { name: '.', columns: 2 },
    { name: '.', columns: 2 },
    { name: 'c', columns: 20 },
    { name: '.', columns: 2 },
  ],
  [Breakpoints.b560]: [
    { name: '.', columns: 4 },
    { name: 'a', columns: 16 },
    { name: '.', columns: 4 },
    { name: '.', columns: 4 },
    { name: 'b', columns: 16 },
    { name: '.', columns: 4 },
    { name: '.', columns: 4 },
    { name: 'c', columns: 16 },
    { name: '.', columns: 4 },
  ],
  [Breakpoints.b960]: [
    { name: '.', columns: 2 },
    { name: 'a', columns: 6 },
    { name: '.', columns: 1 },
    { name: 'b', columns: 6 },
    { name: '.', columns: 1 },
    { name: 'c', columns: 6 },
    { name: '.', columns: 2 },
  ],
};

const oneOffer: LayoutConfiguration = {
  [Breakpoints.default]: [
    { name: '.', columns: 2 },
    { name: 'a', columns: 20 },
    { name: '.', columns: 2 },
    { name: '.', columns: 2 },
    { name: 'b', columns: 20 },
    { name: '.', columns: 2 },
    { name: '.', columns: 2 },
    { name: 'c', columns: 20 },
    { name: '.', columns: 2 },
  ],
  [Breakpoints.b560]: [
    { name: '.', columns: 4 },
    { name: 'a', columns: 16 },
    { name: '.', columns: 4 },
    { name: '.', columns: 4 },
    { name: 'b', columns: 16 },
    { name: '.', columns: 4 },
    { name: '.', columns: 4 },
    { name: 'c', columns: 16 },
    { name: '.', columns: 4 },
  ],
  [Breakpoints.b960]: [
    { name: '.', columns: 4 },
    { name: 'a', columns: 7 },
    { name: '.', columns: 1 },
    { name: 'b', columns: 8 },
    { name: '.', columns: 4 },
  ],
  [Breakpoints.b1280]: [
    { name: '.', columns: 5 },
    { name: 'a', columns: 7 },
    { name: '.', columns: 1 },
    { name: 'b', columns: 7 },
    { name: '.', columns: 4 },
  ],
};

export function CarlineOffer(props: CarlineOfferProps) {
  const carline = useContext(CarlineContext);
  const { offer, offerNumber, activeComparador, numberOfOffers, offerChange, showCard } = props;
  const [showCarline, setShowCarline] = useState<boolean>(false);
  const equipmentDiv = useRef<any>(null);
  const comparadorContainer = useRef<any>(null);
  const mode = useFeatureAppConfig().mode;
  const dataService = getDataServiceConfig();

  useLayoutEffect(() => {
    if (!offerChange) setShowCarline(false);
  }, [offerChange]);

  useLayoutEffect(() => {
    if (offerNumber !== undefined) {
      const offerTimeout = 500 + 400 * offerNumber;
      setTimeout(() => setShowCarline(true), offerTimeout);
    } else {
      setTimeout(() => setShowCarline(true), 500);
    }
  }, [carline]);

  useEffect(() => {
    if (offerNumber !== undefined) {
      const offerTimeout = 500 + 200 * offerNumber;
      setTimeout(() => setShowCarline(true), offerTimeout);
    } else {
      setTimeout(() => setShowCarline(true), 500);
    }
  }, []);


  useEffect(() => {
    const timeout = setTimeout(() => {
      if (comparadorContainer && comparadorContainer.current) {
        if (activeComparador && numberOfOffers > 1 && !showCard && mode !== 'filter') {
          comparadorContainer.current.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
          });
        }
      }
    }, 200);
    return () => clearTimeout(timeout);
  }, [activeComparador]);

  return (
    <CSSTransition timeout={400} in={showCarline} classNames="offer">
      <Offer id={`${offer.prioridad}`} showCard={showCard}>
        <Container stretchContent>
          <Layout appearance={numberOfOffers === 1  ?  (isCommercial(dataService) ? oneOfferCommercial : oneOffer) : moreThanOneOffer}>
            <SideViewImageOffer offer={offer} numberOfOffers={numberOfOffers} />
            <CarlineModelCuotaInfo offer={offer} numberOfOffers={numberOfOffers} />

            {activeComparador ? (
              <CSSTransition timeout={400} classNames="equipamiento" in={activeComparador}>
                <ComparadorContainer ref={comparadorContainer}>
                  <ComparadorWrapper
                    ref={equipmentDiv}
                    oneOffer={numberOfOffers === 1 ? true : false}
                    className="equipment-wrapper"
                  >
                    {!isCommercial(dataService) ?
                      <Comparador offer={offer} numberOfOffers={numberOfOffers} activeComparador={activeComparador} />
                      :
                      <CarlineEquipments equipments={offer.equipamientos} />
                    }
                  </ComparadorWrapper>
                </ComparadorContainer>
              </CSSTransition>
            ) : null}
          </Layout>
        </Container>
      </Offer>
    </CSSTransition>
  );
}
